import React from "react";
import { PaintBrush } from "@phosphor-icons/react";

/**
 * Small chip rendered on order cards / order detail when the order has at
 * least one item at the painter. Reads the rolled-up `paint_out_count` and
 * `paint_oldest_days_out` already present on the /api/orders payload.
 */
export default function OrderPaintChip({ order, className = "" }) {
  const count = Number(order?.paint_out_count) || 0;
  if (count <= 0) return null;
  const oldest = Number(order?.paint_oldest_days_out) || 0;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] font-black rounded-md px-2 py-1 border whitespace-nowrap bg-purple-100 text-purple-800 border-purple-300 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-800 ${className}`}
      data-testid={`order-paint-chip-${order.order_number || order.id}`}
      title={`${count} item(s) at painter · ${oldest}d oldest`}
    >
      <PaintBrush size={11} weight="fill" />
      {count} at painter
      {oldest > 0 && <span className="normal-case tracking-normal">· {oldest}d</span>}
    </span>
  );
}
